import styles from './PageJoin.module.css'
// import VolunteerFlyer from '../../assets/Volunteer Flyer.png';

function PageJoin() {
  return (
    <div className={styles.PageJoin}>
      <div className={styles.CodeAblazeTitle}>
        <h1>Interested in Volunteering?</h1>
      </div>
      <div className={styles.ContentDiv}>
        <div className={styles.DescriptionDiv}>
          At this time, we are accepting high schoolers with fundamental computer science experience. View the flyer in the section below for more information. To apply, navigate to the form linked below, or fill it out on this website.
        </div>
      </div>
      <div className={styles.FormHolder}>
        <iframe title="Volunteer Signup" src="https://docs.google.com/forms/d/e/1FAIpQLSdCKe5JJSrbo0xbqQDwotUryy-2BDbAG04bxtT5vHklXygl5g/viewform?usp=header" width="500px" height="400px"></iframe>
      </div>
      <div>
        <a href="https://docs.google.com/forms/d/e/1FAIpQLSdCKe5JJSrbo0xbqQDwotUryy-2BDbAG04bxtT5vHklXygl5g/viewform?usp=header">Google Form Link</a>
      </div>
      {/* <div className={styles.ImageHolder}>
        <img src={VolunteerFlyer} alt="Volunteer Flyer" />
      </div> */}
      <div className={styles.Spacing} />
    </div>
  );
}

export default PageJoin;
